/* eslint-disable indent */
// @flow
import React, { useCallback, useEffect } from 'react';
import { Container, Button } from 'semantic-ui-react';
import { errorLogger } from '../../helpers';
import * as cssTele2 from './NotEntitledTele2.module.css';
import * as cssComviq from './NotEntitledComviq.module.css';
import Header from 'views/Header';
import Error from 'views/Error';
import ReactGA from 'react-ga';
import Loading, { SadFaceSvg, Footer } from 'components';
import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';
import { isAppleDevice, isComviqCustomer } from '../../helpers/customerTypeHelpers';
import { getContentFor } from '../../helpers/contentHelpers';
import { CustomerTypes } from '../../Constants';

type Props = {
  isAllowedMoreSubscriptions: boolean,
  isAllowedPriceplan: boolean,
  isAllowedTransfer: Boolean,
  errorMessage: String,
  isInvalidCustomerType: boolean,
  isPrepaid: Boolean,
};

const NotEntitled = ({
  isAllowedMoreSubscriptions = true,
  isAllowedPriceplan = true,
  isAllowedTransfer = true,
  errorMessage = '',
  isInvalidCustomerType = false,
  isPrepaid = false,
}: Props) => {
  const loading = useSelector((state) => state.app.isLoading);
  const error = useSelector((state) => state.app.error);
  const customerType = useSelector((state) => state.app.customerType);

  const errorType = getErrorTypeForContent();
  const allContent = getContentFor(customerType);
  const pageContent =
    errorType === 'error' ? allContent.page[String(errorType)] : allContent.page.entitled[String(errorType)];

  const isComviq = isComviqCustomer(customerType);
  const css = isComviq ? cssComviq : cssTele2;
  const buttonClasses = isComviq ? `${css.button}` : ``;

  function getErrorTypeForContent() {
    return !isAllowedMoreSubscriptions && !errorMessage
      ? 'subscription'
      : !isAllowedPriceplan
      ? 'priceplan'
      : isInvalidCustomerType
      ? 'customerType'
      : !isAllowedTransfer
      ? 'transfer'
      : isPrepaid
      ? 'prepaid'
      : 'error';
  };
  const handleClose = useCallback(() => {
    /*eslint-disable no-undef*/
    DataActivationController.doneSelected();
  }, []);

  const triggerTel = (number) => {
    infoLogger({ name: 'client-error-trigger-tel', log: 'Customer triggered call to customer service button' });
    window.location = `tel:${number}`;
  };

  useEffect(() => {
    ReactGA.pageview('/not-entitled');
    const message = error ? error : errorMessage ? errorMessage : pageContent ? pageContent.text : '';

    window.__PAGE__ = 'notEntitled';
    errorLogger({ name: 'client-page-view-notEntitled', log: `Not entitled page showen with error: ${message}` });
  }, []);

  if (loading) return <Loading />;
  if (error) return <Error message={error} />;

  return (
    <>
      <Header />
      <Container as="main">
        <>
          {isComviq && <SadFaceSvg className={css.icon} />}
          <h1 className={css.title}>{pageContent.title}</h1>
          {errorMessage ? (
            // eslint-disable-next-line react/no-danger
            <div className={css.text} dangerouslySetInnerHTML={{ __html: errorMessage }} />
          ) : (
            <ReactMarkdown className={css.text} source={pageContent.text} />
          )}
          <Footer isComviq={isComviq} className={css.button}>
            {isAppleDevice() ? (
              <Button color="blue" className={buttonClasses} primary fluid onClick={handleClose}>
                Stäng
              </Button>
            ) : (
              <Button
                color="blue"
                className={buttonClasses}
                primary
                fluid
                onClick={() => triggerTel(allContent.page.error.number)}
              >
                {allContent.page.error.button}
              </Button>
            )}
          </Footer>
        </>
      </Container>
    </>
  );
};

export default NotEntitled;
